import { QuantitySelectorComponent } from '@theme/component-quantity-selector';

/**
 * Cart Quantity Selector with HARD MAX = 3
 * This overrides Shopify quantity rules safely.
 */
class CartQuantitySelectorComponent extends QuantitySelectorComponent {
  /**
   * HARD LIMIT — change this number if needed
   */
  static HARD_MAX = 3;

  /**
   * Gets the effective maximum value for cart quantity selector
   * We FORCE max = 3 regardless of Shopify rules
   * @returns {number}
   */
  getEffectiveMax() {
    return CartQuantitySelectorComponent.HARD_MAX;
  }

  /**
   * Updates button states based on current value and limits
   */
  updateButtonStates() {
    const { minusButton, plusButton } = this.refs;
    const { min, value } = this.getCurrentValues();
    const effectiveMax = this.getEffectiveMax();

    minusButton.disabled = value <= min;
    plusButton.disabled = value >= effectiveMax;
  }

  /**
   * Ensure manual input also respects MAX = 3
   */
  setQuantity(value) {
    const max = this.getEffectiveMax();
    const min = this.getCurrentValues().min || 1;

    let newValue = Number(value);

    if (newValue > max) newValue = max;
    if (newValue < min) newValue = min;

    super.setQuantity(newValue);
  }

  /**
   * Ensure + button never exceeds MAX = 3
   */
  increaseQuantity() {
    const { value } = this.getCurrentValues();
    const max = this.getEffectiveMax();

    if (value >= max) return;

    super.increaseQuantity();
  }
}

if (!customElements.get('cart-quantity-selector-component')) {
  customElements.define(
    'cart-quantity-selector-component',
    CartQuantitySelectorComponent
  );
}
